module.exports = __webpack_public_path__ + "img/greater_good1.af343538.jpg";